import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import PersonalInformationForm from '../PersonalInformationForm'
import Drawer from 'components/common/Drawer'
import Legend from 'components/common/Legend/Legend'
import Button from 'components/common/Button/Button'
import * as UI from '../Shared.styles'
import { NONE } from '../../constants'
import AddressConfirmationModal from '../AddressConfirmationModal'

const PersonalInformationDrawer = ({
  primaryPhone,
  alternatePhone,
  fullUserName,
  fullUserAddress,
  userBirthday,
  formInitialValues,
  stateOptions,
  expanded: isEditMode,
  toggleHandlers: {
    onClick: onChangeViewMode
  },
  setFocusScopeRef,
  handleUpdatePersonalInformation
}) =>
  <Drawer title="Personal Information" withHeading accordion expandedByDefault preventHandleBlur>
    {
      isEditMode ?
        <PersonalInformationForm
          initialValues={ formInitialValues }
          stateOptions={ stateOptions }
          setFocusScopeRef={ setFocusScopeRef }
          onSubmit={ handleUpdatePersonalInformation }
          onCancel={ onChangeViewMode } /> :
        <Fragment>
          <Name label="Name" data-at-accountdetails-personal-info-name >{ fullUserName }</Name>
          <Name label="Address" data-at-accountdetails-personal-info-address>
            {
              Array.isArray(fullUserAddress) ?
                <Fragment>
                  <Address>{ fullUserAddress[0] }</Address>
                  <Address>{ fullUserAddress[1] }</Address>
                </Fragment> :
                fullUserAddress
            }
          </Name>
          <Name label="Phone Number" data-at-accountdetails-personal-info-phonecell>{ primaryPhone || NONE }</Name>
          <Name label="Other Phone Number" data-at-accountdetails-personal-info-phoneother>{ alternatePhone || NONE }</Name>
          <Name label="Birthday" data-at-accountdetails-personal-info-birthday>{ userBirthday }</Name>
          <UI.Buttons>
            <Button data-at-personal-edit-button onClick={ onChangeViewMode }>Edit</Button>
          </UI.Buttons>
        </Fragment>
    }
    <AddressConfirmationModal />
  </Drawer>

PersonalInformationDrawer.propTypes = {
  alternatePhone: PropTypes.string,
  expanded: PropTypes.bool,
  formInitialValues: PropTypes.shape(),
  fullUserAddress: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fullUserName: PropTypes.string,
  handleUpdatePersonalInformation: PropTypes.func,
  primaryPhone: PropTypes.string,
  setFocusScopeRef: PropTypes.func,
  stateOptions: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape()
  ])),
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  }),
  userBirthday: PropTypes.string
}

export default PersonalInformationDrawer

const Name = styled(Legend)`
  line-height: 19px;
`

const Address = styled.div`
  line-height: 22px;
`
